import React from "react";
import { Checkbox } from "antd";

const ReviewStep = ({

  userType,
  children,
  classOptions,
  acceptedTerms,
  setAcceptedTerms,
}) => {
  return (
    <div className="step-content">
      <h3>Accept Terms</h3>
      <div className="review-section">
        <span>Please review and accept our Terms and Conditions to proceed.</span>
        {userType === "parent" && children.length > 0 && (
          <div>
            <strong>Children:</strong>
            {children.map((child, index) => (
              <div key={index} style={{ marginLeft: 16 }}>
                <p>
                  • {child.name} - {classOptions.find((c) => c.id === child.class_id)?.name || child.class_id}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      <Checkbox checked={acceptedTerms} onChange={(e) => setAcceptedTerms(e.target.checked)}>
        I agree to the <a href="/terms-of-service" target="_blank">Terms and Conditions</a>
      </Checkbox>
    </div>
  );
};

export default ReviewStep;
